import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { registerLocale } from 'react-datepicker';
import { Row, Col, Table, Button, Card, ListGroup } from 'react-bootstrap';

import { connect } from 'react-redux';
import { ASYNC_LANDING_APPROVAL } from 'store';
import BR from 'date-fns/locale/pt-BR';
import style from './style.module.scss';
import { api } from 'services';
import sha1 from 'crypto-js/sha1';
import { parseDateBR } from 'helpers/date';

var CryptoJS = require('crypto-js');

registerLocale('BR', BR);

const MarketingPlanLandingApproval = ({
  landingPageApproval,
  match: {
    params: { hash },
  },
}) => {
  const [data, setData] = useState({ actions: [] });
  const [logoVendor, setLogoVendor] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [period, setPeriod] = useState('');
  const [expectedStartDate, setExpectedStartDate] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [realStartDate, setRealStartDate] = useState('');
  const [realEndDate, setRealEndDate] = useState('');
  // const [comment, setComment] = useState('');
  const { t } = useTranslation();
  const fundsArr = [];
  let decrypt = '';

  useEffect(() => {
    if (hash != null && hash != '')
      api.get(`marketing-plan-by-hash/${hash}`).then(({ data }) => {
        setData(data);
        setCompanyName(data.company.alias);
        if (data.company.logo !== null) setLogoVendor(data.company.logo.uri);
        setPeriod(
          `${data.company_rule.period.type.name} ${data.company_rule.period.position}`
        );
        setExpectedStartDate(
          parseDateBR(data.company_rule.expected_amount_start)
        );
        setExpectedEndDate(parseDateBR(data.company_rule.expected_amount_end));
        setRealStartDate(parseDateBR(data.company_rule.real_amount_start));
        setRealEndDate(parseDateBR(data.company_rule.real_amount_end));
      });
  }, []);

  const fundsObj = (fundTypeId, name) => {
    let obj = {
      fundTypeId: fundTypeId,
      name: name,
      value: totalActionFunds(fundTypeId),
    };
    return obj;
  };

  const existFund = (fundTypeParam) => {
    let flag = true;
    fundsArr.map((fund) => {
      if (fund.fundTypeId === fundTypeParam) {
        flag = false;
      }
    });
    return flag;
  };

  const handleApprove = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('plan_id', data.id);
    formData.append('current_status', data.status_id);
    formData.append('to_status', 8);
    landingPageApproval(formData);
  };

  const handleDisapproved = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('plan_id', data.id);
    formData.append('current_status', data.status_id);
    formData.append('to_status', 7);
    landingPageApproval(formData);
  };

  const wasAvailable = () => {
    let available = '';
    if (data.status_id === 8) {
      available += 'Aprovado';
    } else if (data.status_id === 5) {
      available += 'Reprovado';
    }
    return available;
  };

  const icon = () => {
    let icon = '';
    if (data.status_id === 8) {
      icon = <i style={{ color: 'green' }} className="fas fa-check-circle" />;
    } else if (data.status_id === 5) {
      icon = <i style={{ color: 'red' }} className="fas fa-times-circle" />;
    }
    return icon;
  };

  const setFundType = () => {
    data.actions.map((action) =>
      action.values.map((value) => {
        switch (value.fund_type_id) {
          case 1:
            if (fundsArr.length === 0) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:MDF')));
            } else if (existFund(value.fund_type_id)) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:MDF')));
            }
            break;
          case 2:
            if (fundsArr.length === 0) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:BU')));
            } else if (existFund(value.fund_type_id)) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:BU')));
            }
            break;
          case 3:
            if (fundsArr.length === 0) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:own')));
            } else if (existFund(value.fund_type_id)) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:own')));
            }
            break;
          case 4:
            if (fundsArr.length === 0) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:extra')));
            } else if (existFund(value.fund_type_id)) {
              fundsArr.push(fundsObj(value.fund_type_id, t('label:extra')));
            }
            break;
        }
      })
    );
  };

  const disabled = () => {
    let disable;
    if (data.status_id === 8 || data.status_id === 5) {
      disable = true;
    }
    return disable;
  };

  const totalFunds = () => {
    let count = 0;
    data.actions.map((dt) =>
      dt.all_values.map((value) => (count += parseFloat(value.actual_value*(value.fund.value_cotacao?value.fund.value_cotacao:1))))
    );
    return count.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const totalActionFunds = (fundId) => {
    let countFund = 0;
    data.actions.map((action) => {
      action.values.map((fund) => {
        if (fund.fund_type_id === fundId) {
          countFund += fund.actual_value;
        }
      });
    });
    return countFund.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const getLocale = (currency) => {
    switch (currency) {
      case 1:
        return 'BRL';
        break;
      case 2:
        return 'USD';
        break;
      case 3:
        return 'EUR';
        break;
      default:
        return 'BRL';
        break;
    }
  };

  return (
    <>
      <Row className={style.coloredBand} />
      <div className={style.layout}>
        <div className={style.logos}>
          <img
            src="/logo-light.png"
            alt="Logo ScanSource"
            height={35}
            className={style.image}
          />
          {logoVendor === '' ? (
            ''
          ) : (
              <img src={logoVendor} alt="Logo Vendor" height={50} />
            )}
        </div>
        <Row>
          <Col>
            <h4 className="text-center font-weight-bold">
              {t('title:marketing plan')}
            </h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <h6 className="mt-1 text-center font-weight-bold">
              {icon()} {wasAvailable()}
            </h6>
          </Col>
        </Row>
        <Row className="mt-4 mb-4">
          <Col>
            <Row>
              <Col>
                <Card.Body>
                  <Card.Title className="text-center">
                    {t('label:company')}
                  </Card.Title>
                  <Card.Text className="text-center">{companyName}</Card.Text>
                </Card.Body>
              </Col>
              <Col>
                <Card.Body>
                  <Card.Title className="text-center">
                    {t('label:plan name')}
                  </Card.Title>
                  <Card.Text className="text-center">{data.name}</Card.Text>
                </Card.Body>
              </Col>
              <Col>
                <Card.Body>
                  <Card.Title className="text-center">
                    {t('label:period')}
                  </Card.Title>
                  <Card.Text className="text-center">{period}</Card.Text>
                </Card.Body>
              </Col>
              {data.project_name === null ? (
                ''
              ) : (
                  <Col>
                    <Card.Body>
                      <Card.Title className="text-center">
                        {t('label:project name')}
                      </Card.Title>
                      <Card.Text className="text-center">
                        {data.project_name}
                      </Card.Text>
                    </Card.Body>
                  </Col>
                )}
            </Row>
            <Row className="mt-4">
              <Col className="mt-6">
                <Card.Body>
                  <Card.Title className="font-weight-bold text-center">
                    {t('label:brief description')}
                  </Card.Title>
                  <Card.Text className="pr-4 text-center">
                    {data.description}
                  </Card.Text>
                </Card.Body>
              </Col>
            </Row>
            <hr className={style.colorHr} />
            <Row>
              <Col>
                <h5 className="text-center font-weight-bold mb-3">
                  {t('title:used funds')}
                </h5>
              </Col>
            </Row>
            <Row className=" d-flex justify-content-center">
              <Col xs={8}>
                <Table bordered hover responsive>
                  <thead>
                    <tr>
                      <th className="text-center align-middle">
                        {t('label:type')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:value')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {setFundType()}
                    {fundsArr.map((fund, k) => (
                      <tr key={k}>
                        <td className="text-center align-middle">
                          {fund.name}
                        </td>
                        <td className="text-center align-middle">
                          {fund.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className=" d-flex justify-content-center text-center">
              <Col>
                <Card.Body>
                  <span className="font-weight-bold">
                    {t('label:init expected date')}
                  </span>
                  <p>{expectedStartDate}</p>
                </Card.Body>
                <Card.Body>
                  <span className="font-weight-bold">
                    {t('label:end expected date')}
                  </span>
                  <p>{expectedEndDate}</p>
                </Card.Body>
              </Col>
              <Col xs={6}>
                <Card.Body>
                  <span className="font-weight-bold">
                    {t('label:init real date')}
                  </span>
                  <p>{realStartDate}</p>
                </Card.Body>
                <Card.Body>
                  <span className="font-weight-bold">
                    {t('label:end real date')}
                  </span>
                  <p>{realEndDate}</p>
                </Card.Body>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className={style.colorHr} />
        <Row className="justify-content-center">
          <Col>
            <Row>
              <Col>
                <h5 className="font-weight-bold text-center mb-3">
                  {t('title:actions')}
                </h5>
              </Col>
            </Row>
            <Row>
              <Col>
                <Table bordered hover responsive className=" text-center">
                  <thead>
                    <tr>
                      <th className="text-center align-middle">
                        {t('label:name')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:start date')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:end date')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:payment date')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:value')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:value')+' Real'}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:activity')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.actions.map((act, k) => {
                      let valor = 0;
                      let valorReal = 0;
                      act.all_values.forEach(
                        (value) => {
                          valor += parseFloat(value.actual_value);
                          if(value.fund.currency_id != 1)
                          valorReal += parseFloat(value.actual_value*value.fund.value_cotacao);
                          else
                          valorReal += parseFloat(value.actual_value);
                        }
                      );
                      return (
                        <tr key={k}>
                          <td className="text-center align-middle">
                            {act.name}
                          </td>
                          <td className="text-center align-middle">
                            {parseDateBR(act.start_date)}
                          </td>
                          <td className="text-center align-middle">
                            {parseDateBR(act.end_date)}
                          </td>
                          <td className="text-center align-middle">
                            {parseDateBR(act.payment_date)}
                          </td>
                          <td className="text-center align-middle">
                            {valor.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: getLocale(act.currency)
                            })}
                          </td>
                          <td className="text-center align-middle">
                            {valorReal.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </td>
                          <td className="text-center align-middle">
                            {act.task.task_group.name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="text-center mb-4">
              <Col>
                <ListGroup variant="flush" className="float-right">
                  <ListGroup.Item></ListGroup.Item>
                  <ListGroup.Item>
                    <span className="font-weight-bold">
                      {t('label:total')}:{' '}
                    </span>
                    {totalFunds()}
                  </ListGroup.Item>
                  <ListGroup.Item></ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            {/* <Row>
                            <Col xs={12} md={12}>
                                <Form.Group >
                                    <Form.Label className="font-weight-bold">{t('label:comments')}</Form.Label>
                                    <Form.Control as="textarea" 
                                        rows="4" 
                                        required 
                                        value={comment}
                                        onChange={e => setComment(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row> */}
            {/* <Row className="mt-2">
              <Col xs={1} md={1}>
                <Button
                  size="sm"
                  type="submit"
                  variant="dark"
                  onClick={handleApprove}
                  disabled={disabled()}
                >
                  {t('label:approve')}
                </Button>
              </Col>
              <Col xs={1} md={1}>
                <Button
                  size="sm"
                  type="submit"
                  variant="dark"
                  onClick={handleDisapproved}
                  disabled={disabled()}
                >
                  {t('label:disapprove')}
                </Button>
              </Col>
            </Row> */}
          </Col>
        </Row>
      </div>
      <Row className={style.coloredBand}>
        <Col className="text-center align-middle mt-4">
          Copyright <a href="https://trend2b.com/"> Trend2B </a> &copy;{' '}
          {new Date().getFullYear()}
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  landingPageApproval: (payload) => {
    dispatch({ type: ASYNC_LANDING_APPROVAL, payload });
  },
});

const connectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingPlanLandingApproval);

export default connectRedux;
